import { emptyA4Canvas, fillStyled, fillWhiteBackground, textWidth, fillTextStyled } from '../canvasDraw'
import { mainFrameRect, drawMainFrame } from './rects'
import { textCentered } from './drawUtils'
import { draw2SignatureVerticalLines, draw3GrandHorizontalLines, drawContentHorizontalLines, drawGrandVerticalLine, drawPageNumberRect, drawSmallVerticalLine } from './drawLines'
import { signatureTopY } from './signatureTopY'
import { textPageNumber } from './drawTexts'
import { drawUpperLeftLines, textUpperLeft } from './upper/upperLeft'
import { drawShiftsLines, textShifts } from './middle/shifts'
import { textWorkingTime } from './middle/workingTime'
import { textWeather } from './middle/weather'
import { drawWorkDescription } from './lower/workDescription'
import { drawRemarks } from './lower/remarks'
import { canvasFonted } from '../../fun-js-lib/canvas'
import { drawUpperMiddleLines, textUpperMiddle } from './upper/upperMiddle'

/**
 * @param {import('../constructionLog').ConstructionLog} constructionLog 
 * @param {number} pageI 
 * @param {string} linesColor 
 */
export const mainDailyPageImage = (constructionLog, pageI, linesColor) => {
  let canvas = emptyA4Canvas()
  let context = canvas.getContext('2d')
  fillWhiteBackground(canvas)
  draw(context, constructionLog, pageI, linesColor)
  return canvas.toDataURL('image/jpeg', 1)
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {import('../constructionLog').ConstructionLog} constructionLog 
 * @param {number} pageI 
 * @param {string} linesColor 
 */
const draw = (context, constructionLog, pageI, linesColor) => {
  let frame = mainFrameRect()
  let smallPadding = 30
  let txtPadding = 8
  let line1 = 70
  let page = constructionLog.log_pages[pageI]

  const textUpperRight = () => {
    let x = frame.x + 1000 + 790
    canvasFonted(context, '49px Arial', () =>
      fillStyled(context, linesColor, () =>
        context.fillText('ГРАЂЕВИНСКИ ДНЕВНИК', x + smallPadding, frame.y + line1)
      ))

    let y = frame.y + line1 * 2.5
    let txt1 = 'ДАН'
    let txt1W = textWidth(context, txt1)
    x += smallPadding
    fillStyled(context, linesColor, () =>
      context.fillText(txt1, x, y))

    let lineW = 200
    fillStyled(context, linesColor, () =>
      context.fillRect(x + txt1W + txtPadding, y, lineW, 1))

    canvasFonted(context, '36px Arial', () => {
      textCentered(context, page.day, x + txt1W + txtPadding, y, lineW)
    })

    let txt2 = 'ДАТУМ'
    let txt2W = textWidth(context, txt2)
    x = x + txt1W + txtPadding + lineW + txtPadding
    fillStyled(context, linesColor, () => {
      context.fillText(txt2, x, y)
      context.fillRect(x + txt2W + txtPadding, y, 200, 1)
    })
    canvasFonted(context, '36px Arial', () => {
      textCentered(context, page.date, x + txt2W + txtPadding, y, 200)
    })
  }
  const textOther = () => {
    let y = frame.y + 250 + 360 + 50

    y = signatureTopY()
    let texts3 = ['ВОДЕ ДНЕВНИК:', 'ИЗВОЂАЧ-РУКОВОДИЛАЦ РАДОВА:', 'НАДЗОРНИ ОРГАН:']
    texts3.forEach((t, i) =>
      fillTextStyled(context, t, frame.x + 15 + i * 850 + (i === 2 ? 5 : 0), y + 40, linesColor))
  }

  drawMainFrame(context, linesColor)
  drawGrandVerticalLine(context, linesColor)
  draw3GrandHorizontalLines(context, linesColor)
  draw2SignatureVerticalLines(context, linesColor)
  drawPageNumberRect(context, linesColor)
  drawShiftsLines(context, linesColor)
  drawContentHorizontalLines(context, linesColor)
  drawSmallVerticalLine(context, linesColor)
  drawUpperLeftLines(context, linesColor)
  drawUpperMiddleLines(context, linesColor)
  context.font = '30px Arial'
  textPageNumber(context, page.number)
  textUpperLeft(context, linesColor, constructionLog, page)
  textUpperMiddle(context, linesColor, page)
  textUpperRight()
  textWorkingTime(context, linesColor, page)
  textShifts(context, linesColor, page)
  textWeather(context, linesColor, page)
  textOther()
  drawWorkDescription(context, linesColor, page)
  drawRemarks(context, linesColor, page)
}